import uniqueId from 'lodash/uniqueId';
// Constants
import { PREFIX_QUESTION_LOCAL_ID } from '@/views/question/constants';

export const getQuestionLocalId = () => uniqueId(PREFIX_QUESTION_LOCAL_ID);
export const isQuestionLocalId = (id) => id?.toString()?.indexOf(PREFIX_QUESTION_LOCAL_ID) !== -1;
